/*
Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/
import { css } from '@spectrum-web-components/base';
const styles = css`
:host,:root{--spectrum-global-dimension-scale-factor:1;--spectrum-global-dimension-size-0:0px;--spectrum-global-dimension-size-10:1px;--spectrum-global-dimension-size-25:2px;--spectrum-global-dimension-size-40:3px;--spectrum-global-dimension-size-50:4px;--spectrum-global-dimension-size-65:5px;--spectrum-global-dimension-size-75:6px;--spectrum-global-dimension-size-85:7px;--spectrum-global-dimension-size-100:8px;--spectrum-global-dimension-size-115:9px;--spectrum-global-dimension-size-125:10px;--spectrum-global-dimension-size-130:11px;--spectrum-global-dimension-size-150:12px;--spectrum-global-dimension-size-160:13px;--spectrum-global-dimension-size-175:14px;--spectrum-global-dimension-size-185:15px;--spectrum-global-dimension-size-200:16px;--spectrum-global-dimension-size-225:18px;--spectrum-global-dimension-size-250:20px;--spectrum-global-dimension-size-275:22px;--spectrum-global-dimension-size-300:24px;--spectrum-global-dimension-size-325:26px;--spectrum-global-dimension-size-350:28px;--spectrum-global-dimension-size-400:32px;--spectrum-global-dimension-size-450:36px;--spectrum-global-dimension-size-500:40px;--spectrum-global-dimension-size-550:44px;--spectrum-global-dimension-size-600:48px;--spectrum-global-dimension-size-650:52px;--spectrum-global-dimension-size-675:54px;--spectrum-global-dimension-size-700:56px;--spectrum-global-dimension-size-750:60px;--spectrum-global-dimension-size-800:64px;--spectrum-global-dimension-size-900:72px;--spectrum-global-dimension-size-1000:80px;--spectrum-global-dimension-size-1125:90px;--spectrum-global-dimension-size-1200:96px;--spectrum-global-dimension-size-1250:100px;--spectrum-global-dimension-size-1600:128px;--spectrum-global-dimension-size-1700:136px;--spectrum-global-dimension-size-1800:144px;--spectrum-global-dimension-size-2000:160px;--spectrum-global-dimension-size-2400:192px;--spectrum-global-dimension-size-2500:200px;--spectrum-global-dimension-size-3000:240px;--spectrum-global-dimension-size-3400:272px;--spectrum-global-dimension-size-3600:288px;--spectrum-global-dimension-size-4600:368px;--spectrum-global-dimension-size-5000:400px;--spectrum-global-dimension-size-6000:480px;--spectrum-global-dimension-font-size-25:10px;--spectrum-global-dimension-font-size-50:11px;--spectrum-global-dimension-font-size-75:12px;--spectrum-global-dimension-font-size-100:14px;--spectrum-global-dimension-font-size-150:15px;--spectrum-global-dimension-font-size-200:16px;--spectrum-global-dimension-font-size-300:18px;--spectrum-global-dimension-font-size-400:20px;--spectrum-global-dimension-font-size-500:22px;--spectrum-global-dimension-font-size-600:25px;--spectrum-global-dimension-font-size-700:28px;--spectrum-global-dimension-font-size-800:32px;--spectrum-global-dimension-font-size-900:36px;--spectrum-global-dimension-font-size-1000:40px;--spectrum-global-dimension-font-size-1100:45px;--spectrum-global-dimension-font-size-1200:50px;--spectrum-global-dimension-font-size-1300:60px;--spectrum-alias-item-text-padding-top-l:var(
--spectrum-global-dimension-size-115
);--spectrum-alias-item-text-padding-bottom-s:var(
--spectrum-global-dimension-static-size-65
);--spectrum-alias-item-workflow-padding-left-m:var(
--spectrum-global-dimension-size-125
);--spectrum-alias-item-rounded-workflow-padding-left-m:var(
--spectrum-global-dimension-size-175
);--spectrum-alias-item-rounded-workflow-padding-left-xl:21px;--spectrum-alias-item-mark-padding-top-m:var(
--spectrum-global-dimension-static-size-75
);--spectrum-alias-item-mark-padding-bottom-m:var(
--spectrum-global-dimension-static-size-75
);--spectrum-alias-item-mark-padding-left-m:var(
--spectrum-global-dimension-size-125
);--spectrum-alias-item-control-1-size-l:var(
--spectrum-global-dimension-size-125
);--spectrum-alias-item-control-1-size-xl:var(
--spectrum-global-dimension-size-125
);--spectrum-alias-item-control-2-size-s:var(
--spectrum-global-dimension-size-150
);--spectrum-alias-item-control-3-height-s:var(
--spectrum-global-dimension-size-150
);--spectrum-alias-item-control-3-width-s:23px;--spectrum-alias-item-control-3-width-m:var(
--spectrum-global-dimension-static-size-325
);--spectrum-alias-item-control-3-width-l:29px;--spectrum-alias-item-control-3-width-xl:33px;--spectrum-alias-item-mark-size-m:var(
--spectrum-global-dimension-size-250
);--spectrum-alias-control-two-size-s:var(
--spectrum-global-dimension-size-150
);--spectrum-alias-control-three-height-s:var(
--spectrum-global-dimension-size-150
);--spectrum-alias-control-three-width-s:23px;--spectrum-alias-control-three-width-m:var(
--spectrum-global-dimension-static-size-325
);--spectrum-alias-control-three-width-l:29px;--spectrum-alias-control-three-width-xl:33px;--spectrum-alias-search-padding-left-m:var(
--spectrum-global-dimension-size-125
);--spectrum-alias-focus-ring-radius-default:var(
--spectrum-global-dimension-static-size-100
);--spectrum-alias-workflow-icon-size-l:var(
--spectrum-global-dimension-static-size-250
);--spectrum-alias-ui-icon-chevron-size-75:var(
--spectrum-global-dimension-static-size-125
);--spectrum-alias-ui-icon-chevron-size-100:var(
--spectrum-global-dimension-static-size-125
);--spectrum-alias-ui-icon-chevron-size-200:var(
--spectrum-global-dimension-static-size-150
);--spectrum-alias-ui-icon-chevron-size-300:var(
--spectrum-global-dimension-static-size-175
);--spectrum-alias-ui-icon-chevron-size-400:var(
--spectrum-global-dimension-static-size-200
);--spectrum-alias-ui-icon-chevron-size-500:var(
--spectrum-global-dimension-static-size-200
);--spectrum-alias-ui-icon-checkmark-size-50:var(
--spectrum-global-dimension-static-size-125
);--spectrum-alias-ui-icon-checkmark-size-75:var(
--spectrum-global-dimension-static-size-125
);--spectrum-alias-ui-icon-checkmark-size-100:var(
--spectrum-global-dimension-static-size-125
);--spectrum-alias-ui-icon-checkmark-size-200:var(
--spectrum-global-dimension-static-size-150
);--spectrum-alias-ui-icon-checkmark-size-300:var(
--spectrum-global-dimension-static-size-175
);--spectrum-alias-ui-icon-checkmark-size-400:var(
--spectrum-global-dimension-static-size-200
);--spectrum-alias-ui-icon-checkmark-size-500:var(
--spectrum-global-dimension-static-size-200
);--spectrum-alias-ui-icon-checkmark-size-600:var(
--spectrum-global-dimension-static-size-225
);--spectrum-alias-ui-icon-dash-size-50:var(
--spectrum-global-dimension-static-size-100
);--spectrum-alias-ui-icon-dash-size-75:var(
--spectrum-global-dimension-static-size-100
);--spectrum-alias-ui-icon-dash-size-100:var(
--spectrum-global-dimension-static-size-125
);--spectrum-alias-ui-icon-dash-size-200:var(
--spectrum-global-dimension-static-size-150
);--spectrum-alias-ui-icon-dash-size-300:var(
--spectrum-global-dimension-static-size-150
);--spectrum-alias-ui-icon-dash-size-400:var(
--spectrum-global-dimension-static-size-175
);--spectrum-alias-ui-icon-dash-size-500:var(
--spectrum-global-dimension-static-size-200
);--spectrum-alias-ui-icon-dash-size-600:var(
--spectrum-global-dimension-static-size-225
);--spectrum-alias-ui-icon-cross-size-75:var(
--spectrum-global-dimension-static-size-100
);--spectrum-alias-ui-icon-cross-size-100:var(
--spectrum-global-dimension-static-size-100
);--spectrum-alias-ui-icon-cross-size-200:var(
--spectrum-global-dimension-static-size-125
);--spectrum-alias-ui-icon-cross-size-300:var(
--spectrum-global-dimension-static-size-150
);--spectrum-alias-ui-icon-cross-size-400:var(
--spectrum-global-dimension-static-size-150
);--spectrum-alias-ui-icon-cross-size-500:var(
--spectrum-global-dimension-static-size-175
);--spectrum-alias-ui-icon-cross-size-600:var(
--spectrum-global-dimension-static-size-200
);--spectrum-alias-ui-icon-arrow-size-75:var(
--spectrum-global-dimension-static-size-125
);--spectrum-alias-ui-icon-arrow-size-100:var(
--spectrum-global-dimension-static-size-125
);--spectrum-alias-ui-icon-arrow-size-200:var(
--spectrum-global-dimension-static-size-150
);--spectrum-alias-ui-icon-arrow-size-300:var(
--spectrum-global-dimension-static-size-175
);--spectrum-alias-ui-icon-arrow-size-400:var(
--spectrum-global-dimension-static-size-200
);--spectrum-alias-ui-icon-arrow-size-500:var(
--spectrum-global-dimension-static-size-225
);--spectrum-alias-ui-icon-arrow-size-600:var(
--spectrum-global-dimension-static-size-250
);--spectrum-alias-ui-icon-triplegripper-size-100-width:var(
--spectrum-global-dimension-static-size-125
);--spectrum-alias-ui-icon-doublegripper-size-100-height:var(
--spectrum-global-dimension-static-size-50
);--spectrum-alias-ui-icon-singlegripper-size-100-height:var(
--spectrum-global-dimension-static-size-25
);--spectrum-alias-ui-icon-cornertriangle-size-100:var(
--spectrum-global-dimension-static-size-65
);--spectrum-alias-ui-icon-cornertriangle-size-300:var(
--spectrum-global-dimension-static-size-85
);--spectrum-alias-ui-icon-asterisk-size-200:var(
--spectrum-global-dimension-static-size-125
);--spectrum-alias-ui-icon-asterisk-size-300:var(
--spectrum-global-dimension-static-size-125
);--spectrum-alias-avatar-size-100:var(--spectrum-global-dimension-size-250);--spectrum-alias-avatar-size-400:var(--spectrum-global-dimension-size-350);--spectrum-alias-avatar-size-600:var(--spectrum-global-dimension-size-450);--spectrum-dragthumb-swatch-width:var(
--spectrum-global-dimension-static-size-150
);--spectrum-dragthumb-swatch-height:var(
--spectrum-global-dimension-static-size-200
);--spectrum-actionbutton-s-quiet-emphasized-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-quiet-emphasized-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-emphasized-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-emphasized-black-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-quiet-emphasized-black-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-emphasized-black-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-emphasized-white-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-quiet-emphasized-white-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-emphasized-white-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-black-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-quiet-black-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-black-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-white-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-quiet-white-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-white-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-emphasized-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-emphasized-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-emphasized-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-emphasized-black-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-emphasized-black-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-emphasized-black-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-emphasized-white-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-emphasized-white-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-emphasized-white-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-black-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-black-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-black-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-white-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-white-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-white-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-emphasized-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-quiet-emphasized-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-emphasized-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-emphasized-black-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-quiet-emphasized-black-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-emphasized-black-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-emphasized-white-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-quiet-emphasized-white-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-emphasized-white-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-black-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-quiet-black-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-black-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-white-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-quiet-white-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-white-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-emphasized-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-emphasized-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-emphasized-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-emphasized-black-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-emphasized-black-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-emphasized-black-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-emphasized-white-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-emphasized-white-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-emphasized-white-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-black-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-black-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-black-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-white-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-white-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-white-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-emphasized-icononly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-quiet-emphasized-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-emphasized-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-emphasized-black-icononly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-quiet-emphasized-black-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-emphasized-black-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-emphasized-white-icononly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-quiet-emphasized-white-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-emphasized-white-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-icononly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-quiet-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-black-icononly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-quiet-black-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-black-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-white-icononly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-quiet-white-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-quiet-white-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-emphasized-icononly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-emphasized-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-emphasized-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-emphasized-black-icononly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-emphasized-black-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-emphasized-black-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-emphasized-white-icononly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-emphasized-white-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-emphasized-white-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-icononly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-black-icononly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-black-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-black-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-white-icononly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-actionbutton-s-white-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-s-white-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-emphasized-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-emphasized-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-emphasized-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-actionbutton-m-quiet-emphasized-black-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-emphasized-black-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-emphasized-black-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-actionbutton-m-quiet-emphasized-white-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-emphasized-white-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-emphasized-white-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-actionbutton-m-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-actionbutton-m-quiet-black-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-black-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-black-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-actionbutton-m-quiet-white-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-white-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-white-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-actionbutton-m-emphasized-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-emphasized-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-emphasized-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-actionbutton-m-emphasized-black-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-emphasized-black-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-emphasized-black-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-actionbutton-m-emphasized-white-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-emphasized-white-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-emphasized-white-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-actionbutton-m-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-actionbutton-m-black-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-black-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-black-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-actionbutton-m-white-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-white-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-white-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-actionbutton-m-quiet-emphasized-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-emphasized-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-emphasized-black-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-emphasized-black-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-emphasized-white-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-emphasized-white-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-black-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-black-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-white-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-white-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-emphasized-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-emphasized-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-emphasized-black-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-emphasized-black-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-emphasized-white-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-emphasized-white-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-black-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-black-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-white-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-white-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-emphasized-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-emphasized-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-emphasized-black-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-emphasized-black-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-emphasized-white-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-emphasized-white-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-black-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-black-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-white-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-quiet-white-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-emphasized-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-emphasized-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-emphasized-black-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-emphasized-black-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-emphasized-white-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-emphasized-white-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-black-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-black-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-white-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-m-white-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-emphasized-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-quiet-emphasized-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-quiet-emphasized-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-emphasized-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-emphasized-black-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-quiet-emphasized-black-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-quiet-emphasized-black-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-emphasized-black-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-emphasized-white-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-quiet-emphasized-white-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-quiet-emphasized-white-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-emphasized-white-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-quiet-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-black-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-quiet-black-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-quiet-black-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-black-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-white-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-quiet-white-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-quiet-white-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-white-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-emphasized-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-emphasized-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-emphasized-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-emphasized-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-emphasized-black-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-emphasized-black-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-emphasized-black-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-emphasized-black-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-emphasized-white-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-emphasized-white-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-emphasized-white-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-emphasized-white-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-black-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-black-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-black-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-black-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-white-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-white-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-white-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-white-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-emphasized-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-quiet-emphasized-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-quiet-emphasized-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-emphasized-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-emphasized-black-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-quiet-emphasized-black-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-quiet-emphasized-black-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-emphasized-black-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-emphasized-white-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-quiet-emphasized-white-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-quiet-emphasized-white-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-emphasized-white-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-quiet-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-black-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-quiet-black-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-quiet-black-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-black-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-white-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-quiet-white-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-quiet-white-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-white-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-emphasized-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-emphasized-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-emphasized-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-emphasized-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-emphasized-black-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-emphasized-black-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-emphasized-black-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-emphasized-black-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-emphasized-white-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-emphasized-white-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-emphasized-white-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-emphasized-white-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-black-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-black-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-black-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-black-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-white-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-white-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-white-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-white-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-emphasized-icononly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-quiet-emphasized-icononly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-quiet-emphasized-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-emphasized-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-emphasized-black-icononly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-quiet-emphasized-black-icononly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-quiet-emphasized-black-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-emphasized-black-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-emphasized-white-icononly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-quiet-emphasized-white-icononly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-quiet-emphasized-white-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-emphasized-white-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-icononly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-quiet-icononly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-quiet-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-black-icononly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-quiet-black-icononly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-quiet-black-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-black-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-white-icononly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-quiet-white-icononly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-quiet-white-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-quiet-white-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-emphasized-icononly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-emphasized-icononly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-emphasized-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-emphasized-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-emphasized-black-icononly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-emphasized-black-icononly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-emphasized-black-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-emphasized-black-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-emphasized-white-icononly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-emphasized-white-icononly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-emphasized-white-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-emphasized-white-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-icononly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-icononly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-black-icononly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-black-icononly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-black-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-black-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-white-icononly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-actionbutton-l-white-icononly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-actionbutton-l-white-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-l-white-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-emphasized-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-emphasized-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-emphasized-black-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-emphasized-black-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-emphasized-white-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-emphasized-white-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-black-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-black-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-white-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-white-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-emphasized-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-emphasized-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-emphasized-black-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-emphasized-black-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-emphasized-white-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-emphasized-white-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-black-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-black-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-white-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-white-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-emphasized-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-emphasized-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-emphasized-black-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-emphasized-black-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-emphasized-white-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-emphasized-white-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-black-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-black-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-white-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-white-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-emphasized-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-emphasized-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-emphasized-black-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-emphasized-black-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-emphasized-white-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-emphasized-white-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-black-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-black-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-white-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-white-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-emphasized-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-emphasized-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-emphasized-black-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-emphasized-black-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-emphasized-white-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-emphasized-white-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-black-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-black-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-white-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-quiet-white-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-emphasized-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-emphasized-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-emphasized-black-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-emphasized-black-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-emphasized-white-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-emphasized-white-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-black-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-black-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-white-icononly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-actionbutton-xl-white-icononly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-badge-s-fuchsia-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-indigo-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-informative-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-magenta-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-negative-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-neutral-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-positive-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-purple-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-seafoam-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-yellow-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-fuchsia-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-indigo-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-informative-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-magenta-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-negative-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-neutral-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-positive-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-purple-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-seafoam-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-yellow-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-fuchsia-icononly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-indigo-icononly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-informative-icononly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-magenta-icononly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-negative-icononly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-neutral-icononly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-positive-icononly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-purple-icononly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-seafoam-icononly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-s-yellow-icononly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-badge-m-fuchsia-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-badge-m-indigo-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-badge-m-informative-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-badge-m-magenta-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-badge-m-negative-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-badge-m-neutral-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-badge-m-positive-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-badge-m-purple-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-badge-m-seafoam-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-badge-m-yellow-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-badge-l-fuchsia-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-fuchsia-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-indigo-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-indigo-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-informative-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-informative-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-magenta-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-magenta-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-negative-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-negative-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-neutral-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-neutral-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-positive-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-positive-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-purple-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-purple-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-seafoam-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-seafoam-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-yellow-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-yellow-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-fuchsia-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-fuchsia-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-indigo-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-indigo-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-informative-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-informative-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-magenta-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-magenta-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-negative-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-negative-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-neutral-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-neutral-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-positive-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-positive-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-purple-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-purple-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-seafoam-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-seafoam-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-yellow-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-yellow-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-fuchsia-icononly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-fuchsia-icononly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-indigo-icononly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-indigo-icononly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-informative-icononly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-informative-icononly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-magenta-icononly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-magenta-icononly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-negative-icononly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-negative-icononly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-neutral-icononly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-neutral-icononly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-positive-icononly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-positive-icononly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-purple-icononly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-purple-icononly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-seafoam-icononly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-seafoam-icononly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-badge-l-yellow-icononly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-badge-l-yellow-icononly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-breadcrumb-s-multiline-button-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-breadcrumb-s-multiline-item-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-breadcrumb-s-multiline-item-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-breadcrumb-s-button-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-breadcrumb-s-item-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-breadcrumb-s-item-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-breadcrumb-m-multiline-button-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-breadcrumb-m-multiline-item-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-breadcrumb-m-button-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-breadcrumb-m-item-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-breadcrumb-l-multiline-button-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-breadcrumb-l-multiline-item-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-breadcrumb-l-multiline-item-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-breadcrumb-l-button-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-breadcrumb-l-item-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-breadcrumb-l-item-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-cta-quiet-overbackground-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-cta-quiet-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-cta-quiet-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-cta-quiet-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-cta-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-cta-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-cta-overbackground-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-cta-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-cta-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-cta-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-cta-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-cta-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-primary-quiet-overbackground-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-primary-quiet-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-primary-quiet-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-primary-quiet-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-primary-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-primary-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-primary-overbackground-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-primary-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-primary-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-primary-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-primary-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-primary-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-secondary-quiet-overbackground-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-secondary-quiet-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-secondary-quiet-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-secondary-quiet-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-secondary-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-secondary-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-secondary-overbackground-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-secondary-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-secondary-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-secondary-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-secondary-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-secondary-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-negative-quiet-overbackground-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-negative-quiet-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-negative-quiet-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-negative-quiet-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-negative-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-negative-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-negative-overbackground-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-negative-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-negative-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-negative-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-negative-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-negative-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-cta-quiet-overbackground-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-cta-quiet-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-cta-quiet-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-cta-quiet-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-cta-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-cta-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-cta-overbackground-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-cta-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-cta-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-cta-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-cta-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-cta-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-primary-quiet-overbackground-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-primary-quiet-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-primary-quiet-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-primary-quiet-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-primary-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-primary-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-primary-overbackground-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-primary-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-primary-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-primary-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-primary-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-primary-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-secondary-quiet-overbackground-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-secondary-quiet-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-secondary-quiet-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-secondary-quiet-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-secondary-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-secondary-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-secondary-overbackground-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-secondary-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-secondary-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-secondary-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-secondary-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-secondary-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-negative-quiet-overbackground-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-negative-quiet-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-negative-quiet-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-negative-quiet-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-negative-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-negative-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-negative-overbackground-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-negative-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-negative-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-negative-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-button-s-negative-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-s-negative-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-cta-quiet-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-cta-quiet-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-cta-quiet-overbackground-texticon-padding-left:var(
--spectrum-global-dimension-size-175
);--spectrum-button-m-cta-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-cta-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-cta-quiet-texticon-padding-left:var(
--spectrum-global-dimension-size-175
);--spectrum-button-m-cta-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-cta-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-cta-overbackground-texticon-padding-left:var(
--spectrum-global-dimension-size-175
);--spectrum-button-m-cta-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-cta-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-cta-texticon-padding-left:var(
--spectrum-global-dimension-size-175
);--spectrum-button-m-primary-quiet-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-primary-quiet-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-primary-quiet-overbackground-texticon-padding-left:var(
--spectrum-global-dimension-size-175
);--spectrum-button-m-primary-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-primary-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-primary-quiet-texticon-padding-left:var(
--spectrum-global-dimension-size-175
);--spectrum-button-m-primary-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-primary-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-primary-overbackground-texticon-padding-left:var(
--spectrum-global-dimension-size-175
);--spectrum-button-m-primary-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-primary-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-primary-texticon-padding-left:var(
--spectrum-global-dimension-size-175
);--spectrum-button-m-secondary-quiet-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-secondary-quiet-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-secondary-quiet-overbackground-texticon-padding-left:var(
--spectrum-global-dimension-size-175
);--spectrum-button-m-secondary-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-secondary-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-secondary-quiet-texticon-padding-left:var(
--spectrum-global-dimension-size-175
);--spectrum-button-m-secondary-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-secondary-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-secondary-overbackground-texticon-padding-left:var(
--spectrum-global-dimension-size-175
);--spectrum-button-m-secondary-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-secondary-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-secondary-texticon-padding-left:var(
--spectrum-global-dimension-size-175
);--spectrum-button-m-negative-quiet-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-negative-quiet-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-negative-quiet-overbackground-texticon-padding-left:var(
--spectrum-global-dimension-size-175
);--spectrum-button-m-negative-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-negative-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-negative-quiet-texticon-padding-left:var(
--spectrum-global-dimension-size-175
);--spectrum-button-m-negative-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-negative-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-negative-overbackground-texticon-padding-left:var(
--spectrum-global-dimension-size-175
);--spectrum-button-m-negative-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-negative-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-negative-texticon-padding-left:var(
--spectrum-global-dimension-size-175
);--spectrum-button-m-cta-quiet-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-cta-quiet-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-cta-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-cta-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-cta-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-cta-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-cta-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-cta-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-primary-quiet-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-primary-quiet-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-primary-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-primary-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-primary-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-primary-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-primary-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-primary-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-secondary-quiet-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-secondary-quiet-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-secondary-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-secondary-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-secondary-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-secondary-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-secondary-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-secondary-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-negative-quiet-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-negative-quiet-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-negative-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-negative-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-negative-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-negative-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-negative-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-m-negative-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-cta-quiet-overbackground-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-cta-quiet-overbackground-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-cta-quiet-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-cta-quiet-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-cta-quiet-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-cta-quiet-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-cta-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-cta-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-cta-overbackground-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-cta-overbackground-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-cta-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-cta-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-cta-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-cta-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-cta-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-cta-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-primary-quiet-overbackground-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-primary-quiet-overbackground-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-primary-quiet-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-primary-quiet-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-primary-quiet-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-primary-quiet-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-primary-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-primary-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-primary-overbackground-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-primary-overbackground-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-primary-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-primary-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-primary-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-primary-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-primary-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-primary-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-secondary-quiet-overbackground-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-secondary-quiet-overbackground-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-secondary-quiet-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-secondary-quiet-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-secondary-quiet-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-secondary-quiet-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-secondary-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-secondary-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-secondary-overbackground-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-secondary-overbackground-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-secondary-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-secondary-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-secondary-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-secondary-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-secondary-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-secondary-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-negative-quiet-overbackground-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-negative-quiet-overbackground-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-negative-quiet-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-negative-quiet-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-negative-quiet-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-negative-quiet-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-negative-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-negative-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-negative-overbackground-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-negative-overbackground-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-negative-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-negative-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-negative-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-negative-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-negative-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-negative-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-cta-quiet-overbackground-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-cta-quiet-overbackground-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-cta-quiet-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-cta-quiet-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-cta-quiet-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-cta-quiet-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-cta-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-cta-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-cta-overbackground-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-cta-overbackground-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-cta-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-cta-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-cta-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-cta-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-cta-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-cta-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-primary-quiet-overbackground-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-primary-quiet-overbackground-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-primary-quiet-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-primary-quiet-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-primary-quiet-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-primary-quiet-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-primary-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-primary-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-primary-overbackground-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-primary-overbackground-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-primary-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-primary-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-primary-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-primary-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-primary-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-primary-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-secondary-quiet-overbackground-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-secondary-quiet-overbackground-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-secondary-quiet-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-secondary-quiet-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-secondary-quiet-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-secondary-quiet-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-secondary-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-secondary-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-secondary-overbackground-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-secondary-overbackground-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-secondary-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-secondary-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-secondary-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-secondary-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-secondary-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-secondary-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-negative-quiet-overbackground-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-negative-quiet-overbackground-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-negative-quiet-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-negative-quiet-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-negative-quiet-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-negative-quiet-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-negative-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-negative-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-negative-overbackground-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-negative-overbackground-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-negative-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-negative-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-negative-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-button-l-negative-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-button-l-negative-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-l-negative-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-cta-quiet-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-cta-quiet-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-cta-quiet-overbackground-texticon-padding-left:21px;--spectrum-button-xl-cta-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-cta-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-cta-quiet-texticon-padding-left:21px;--spectrum-button-xl-cta-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-cta-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-cta-overbackground-texticon-padding-left:21px;--spectrum-button-xl-cta-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-cta-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-cta-texticon-padding-left:21px;--spectrum-button-xl-primary-quiet-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-primary-quiet-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-primary-quiet-overbackground-texticon-padding-left:21px;--spectrum-button-xl-primary-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-primary-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-primary-quiet-texticon-padding-left:21px;--spectrum-button-xl-primary-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-primary-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-primary-overbackground-texticon-padding-left:21px;--spectrum-button-xl-primary-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-primary-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-primary-texticon-padding-left:21px;--spectrum-button-xl-secondary-quiet-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-secondary-quiet-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-secondary-quiet-overbackground-texticon-padding-left:21px;--spectrum-button-xl-secondary-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-secondary-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-secondary-quiet-texticon-padding-left:21px;--spectrum-button-xl-secondary-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-secondary-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-secondary-overbackground-texticon-padding-left:21px;--spectrum-button-xl-secondary-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-secondary-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-secondary-texticon-padding-left:21px;--spectrum-button-xl-negative-quiet-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-negative-quiet-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-negative-quiet-overbackground-texticon-padding-left:21px;--spectrum-button-xl-negative-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-negative-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-negative-quiet-texticon-padding-left:21px;--spectrum-button-xl-negative-overbackground-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-negative-overbackground-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-negative-overbackground-texticon-padding-left:21px;--spectrum-button-xl-negative-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-negative-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-negative-texticon-padding-left:21px;--spectrum-button-xl-cta-quiet-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-cta-quiet-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-cta-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-cta-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-cta-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-cta-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-cta-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-cta-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-primary-quiet-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-primary-quiet-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-primary-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-primary-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-primary-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-primary-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-primary-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-primary-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-secondary-quiet-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-secondary-quiet-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-secondary-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-secondary-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-secondary-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-secondary-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-secondary-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-secondary-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-negative-quiet-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-negative-quiet-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-negative-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-negative-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-negative-overbackground-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-negative-overbackground-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-negative-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-button-xl-negative-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-checkbox-s-emphasized-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-checkbox-s-emphasized-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-checkbox-s-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-checkbox-s-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-checkbox-m-emphasized-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-checkbox-m-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-checkbox-l-emphasized-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-checkbox-l-emphasized-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-checkbox-l-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-checkbox-l-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-checkbox-xl-emphasized-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-checkbox-xl-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-colorloupe-colorhandle-gap:var(
--spectrum-global-dimension-static-size-125
);--spectrum-colorloupe-offset-y:var(
--spectrum-global-dimension-static-size-125
);--spectrum-colorslider-vertical-touch-hit-x:var(
--spectrum-global-dimension-size-150
);--spectrum-colorslider-touch-hit-y:var(
--spectrum-global-dimension-size-150
);--spectrum-colorwheel-min-size:var(--spectrum-global-dimension-size-2400);--spectrum-colorwheel-touch-hit-outer:var(
--spectrum-global-dimension-size-150
);--spectrum-colorwheel-touch-hit-inner:var(
--spectrum-global-dimension-size-150
);--spectrum-colorwheel-min-width:var(--spectrum-global-dimension-size-2400);--spectrum-colorwheel-min-height:var(
--spectrum-global-dimension-size-2400
);--spectrum-combobox-s-quiet-placeholder-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-combobox-s-quiet-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-combobox-s-placeholder-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-combobox-s-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-combobox-l-quiet-placeholder-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-combobox-l-quiet-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-combobox-l-placeholder-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-combobox-l-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-cyclebutton-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-cyclebutton-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-dialog-confirm-title-text-size:var(
--spectrum-alias-heading-s-text-size
);--spectrum-dialog-confirm-description-text-size:var(
--spectrum-global-dimension-font-size-100
);--spectrum-dialog-confirm-description-margin-bottom:var(
--spectrum-global-dimension-static-size-600
);--spectrum-dialog-confirm-max-width:var(
--spectrum-global-dimension-static-size-6000
);--spectrum-dialog-confirm-padding:var(
--spectrum-global-dimension-static-size-500
);--spectrum-dialog-destructive-title-text-size:var(
--spectrum-alias-heading-s-text-size
);--spectrum-dialog-destructive-description-text-size:var(
--spectrum-global-dimension-font-size-100
);--spectrum-dialog-destructive-description-margin-bottom:var(
--spectrum-global-dimension-static-size-600
);--spectrum-dialog-destructive-max-width:var(
--spectrum-global-dimension-static-size-6000
);--spectrum-dialog-destructive-padding:var(
--spectrum-global-dimension-static-size-500
);--spectrum-dialog-error-title-text-size:var(
--spectrum-alias-heading-s-text-size
);--spectrum-dialog-error-description-text-size:var(
--spectrum-global-dimension-font-size-100
);--spectrum-dialog-error-description-margin-bottom:var(
--spectrum-global-dimension-static-size-600
);--spectrum-dialog-error-max-width:var(
--spectrum-global-dimension-static-size-6000
);--spectrum-dialog-error-padding:var(
--spectrum-global-dimension-static-size-500
);--spectrum-dialog-info-title-text-size:var(
--spectrum-alias-heading-s-text-size
);--spectrum-dialog-info-description-text-size:var(
--spectrum-global-dimension-font-size-100
);--spectrum-dialog-info-description-margin-bottom:var(
--spectrum-global-dimension-static-size-600
);--spectrum-dialog-info-max-width:var(
--spectrum-global-dimension-static-size-6000
);--spectrum-dialog-info-padding:var(
--spectrum-global-dimension-static-size-500
);--spectrum-dialog-fullscreen-title-text-size:var(
--spectrum-alias-heading-s-text-size
);--spectrum-dialog-fullscreen-description-text-size:var(
--spectrum-global-dimension-font-size-100
);--spectrum-dialog-fullscreen-description-margin-bottom:var(
--spectrum-global-dimension-static-size-600
);--spectrum-dialog-fullscreen-max-width:var(
--spectrum-global-dimension-static-size-6000
);--spectrum-dialog-fullscreen-padding:var(
--spectrum-global-dimension-static-size-500
);--spectrum-dialog-fullscreentakeover-title-text-size:var(
--spectrum-alias-heading-s-text-size
);--spectrum-dialog-fullscreentakeover-description-text-size:var(
--spectrum-global-dimension-font-size-100
);--spectrum-dialog-fullscreentakeover-description-margin-bottom:var(
--spectrum-global-dimension-static-size-600
);--spectrum-dialog-fullscreentakeover-max-width:var(
--spectrum-global-dimension-static-size-6000
);--spectrum-dialog-fullscreentakeover-padding:var(
--spectrum-global-dimension-static-size-500
);--spectrum-helptext-s-neutral-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-helptext-s-negative-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-helptext-s-neutral-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-helptext-s-negative-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-helptext-m-neutral-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-helptext-m-negative-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-helptext-m-neutral-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-helptext-m-negative-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-helptext-l-neutral-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-helptext-l-negative-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-helptext-l-neutral-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-helptext-l-negative-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-helptext-xl-neutral-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-helptext-xl-negative-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-helptext-xl-neutral-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-helptext-xl-negative-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-infieldbutton-l-left-fill-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-infieldbutton-l-right-fill-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-infieldbutton-l-none-fill-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-listitem-s-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-listitem-s-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-listitem-s-textthumbnail-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-listitem-m-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-listitem-m-textthumbnail-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-listitem-l-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-listitem-l-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-listitem-l-texticon-thumbnail-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-listitem-l-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-listitem-l-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-listitem-l-textonly-thumbnail-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-listitem-l-textthumbnail-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-listitem-l-textthumbnail-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-listitem-l-textthumbnail-thumbnail-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-meter-s-negative-overbackground-value-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-meter-s-negative-overbackground-border-radius:var(
--spectrum-global-dimension-static-size-25
);--spectrum-meter-s-negative-value-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-meter-s-negative-border-radius:var(
--spectrum-global-dimension-static-size-25
);--spectrum-meter-s-notice-overbackground-value-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-meter-s-notice-overbackground-border-radius:var(
--spectrum-global-dimension-static-size-25
);--spectrum-meter-s-notice-value-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-meter-s-notice-border-radius:var(
--spectrum-global-dimension-static-size-25
);--spectrum-meter-s-positive-overbackground-value-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-meter-s-positive-overbackground-border-radius:var(
--spectrum-global-dimension-static-size-25
);--spectrum-meter-s-positive-value-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-meter-s-positive-border-radius:var(
--spectrum-global-dimension-static-size-25
);--spectrum-meter-m-negative-overbackground-border-radius:var(
--spectrum-global-dimension-static-size-40
);--spectrum-meter-m-negative-border-radius:var(
--spectrum-global-dimension-static-size-40
);--spectrum-meter-m-notice-overbackground-border-radius:var(
--spectrum-global-dimension-static-size-40
);--spectrum-meter-m-notice-border-radius:var(
--spectrum-global-dimension-static-size-40
);--spectrum-meter-m-positive-overbackground-border-radius:var(
--spectrum-global-dimension-static-size-40
);--spectrum-meter-m-positive-border-radius:var(
--spectrum-global-dimension-static-size-40
);--spectrum-meter-l-negative-overbackground-value-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-meter-l-negative-value-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-meter-l-notice-overbackground-value-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-meter-l-notice-value-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-meter-l-positive-overbackground-value-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-meter-l-positive-value-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-meter-xl-negative-overbackground-border-radius:var(
--spectrum-global-dimension-static-size-65
);--spectrum-meter-xl-negative-border-radius:var(
--spectrum-global-dimension-static-size-65
);--spectrum-meter-xl-notice-overbackground-border-radius:var(
--spectrum-global-dimension-static-size-65
);--spectrum-meter-xl-notice-border-radius:var(
--spectrum-global-dimension-static-size-65
);--spectrum-meter-xl-positive-overbackground-border-radius:var(
--spectrum-global-dimension-static-size-65
);--spectrum-meter-xl-positive-border-radius:var(
--spectrum-global-dimension-static-size-65
);--spectrum-pagination-page-button-line-height:26px;--spectrum-pagination-button-page-button-line-height:26px;--spectrum-pagination-explicit-page-button-line-height:26px;--spectrum-pagination-listing-page-button-line-height:26px;--spectrum-panel-s-collapsible-header-height:var(
--spectrum-global-dimension-size-600
);--spectrum-panel-s-header-height:var(--spectrum-global-dimension-size-600);--spectrum-panel-s-spacious-collapsible-header-height:var(
--spectrum-global-dimension-size-600
);--spectrum-panel-s-spacious-header-height:var(
--spectrum-global-dimension-size-600
);--spectrum-panel-l-collapsible-header-height:var(
--spectrum-global-dimension-size-600
);--spectrum-panel-l-header-height:var(--spectrum-global-dimension-size-600);--spectrum-panel-l-spacious-collapsible-header-height:var(
--spectrum-global-dimension-size-600
);--spectrum-panel-l-spacious-header-height:var(
--spectrum-global-dimension-size-600
);--spectrum-picker-s-quiet-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-picker-s-quiet-texticon-placeholder-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-picker-s-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-s-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-s-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-picker-s-texticon-placeholder-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-picker-s-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-s-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-s-quiet-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-picker-s-quiet-textonly-placeholder-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-picker-s-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-s-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-s-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-picker-s-textonly-placeholder-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-picker-s-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-s-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-s-quiet-textthumbnail-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-picker-s-quiet-textthumbnail-placeholder-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-picker-s-quiet-textthumbnail-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-s-quiet-textthumbnail-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-s-textthumbnail-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-picker-s-textthumbnail-placeholder-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-picker-s-textthumbnail-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-s-textthumbnail-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-m-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-m-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-m-texticon-popover-offset-x:var(
--spectrum-global-dimension-size-125
);--spectrum-picker-m-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-picker-m-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-m-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-m-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-m-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-m-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-m-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-m-quiet-textthumbnail-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-m-quiet-textthumbnail-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-m-textthumbnail-popover-offset-x:var(
--spectrum-global-dimension-size-125
);--spectrum-picker-m-textthumbnail-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-picker-m-textthumbnail-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-m-textthumbnail-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-l-quiet-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-picker-l-quiet-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-picker-l-quiet-texticon-placeholder-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-picker-l-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-l-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-l-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-picker-l-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-picker-l-texticon-placeholder-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-picker-l-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-l-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-l-quiet-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-picker-l-quiet-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-picker-l-quiet-textonly-placeholder-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-picker-l-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-l-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-l-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-picker-l-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-picker-l-textonly-placeholder-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-picker-l-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-l-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-l-quiet-textthumbnail-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-picker-l-quiet-textthumbnail-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-picker-l-quiet-textthumbnail-placeholder-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-picker-l-quiet-textthumbnail-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-l-quiet-textthumbnail-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-l-textthumbnail-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-picker-l-textthumbnail-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-picker-l-textthumbnail-placeholder-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-picker-l-textthumbnail-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-l-textthumbnail-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-xl-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-xl-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-xl-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-xl-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-xl-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-xl-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-xl-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-xl-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-xl-quiet-textthumbnail-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-xl-quiet-textthumbnail-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-xl-textthumbnail-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-picker-xl-textthumbnail-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-progressbar-s-indeterminate-overbackground-value-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-progressbar-s-indeterminate-overbackground-border-radius:var(
--spectrum-global-dimension-static-size-25
);--spectrum-progressbar-s-indeterminate-value-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-progressbar-s-indeterminate-border-radius:var(
--spectrum-global-dimension-static-size-25
);--spectrum-progressbar-s-overbackground-value-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-progressbar-s-overbackground-border-radius:var(
--spectrum-global-dimension-static-size-25
);--spectrum-progressbar-s-value-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-progressbar-s-border-radius:var(
--spectrum-global-dimension-static-size-25
);--spectrum-progressbar-m-indeterminate-overbackground-border-radius:var(
--spectrum-global-dimension-static-size-40
);--spectrum-progressbar-m-indeterminate-border-radius:var(
--spectrum-global-dimension-static-size-40
);--spectrum-progressbar-m-overbackground-border-radius:var(
--spectrum-global-dimension-static-size-40
);--spectrum-progressbar-m-border-radius:var(
--spectrum-global-dimension-static-size-40
);--spectrum-progressbar-l-indeterminate-overbackground-value-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-progressbar-l-indeterminate-value-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-progressbar-l-overbackground-value-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-progressbar-l-value-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-progressbar-xl-indeterminate-overbackground-border-radius:var(
--spectrum-global-dimension-static-size-65
);--spectrum-progressbar-xl-indeterminate-border-radius:var(
--spectrum-global-dimension-static-size-65
);--spectrum-progressbar-xl-overbackground-border-radius:var(
--spectrum-global-dimension-static-size-65
);--spectrum-progressbar-xl-border-radius:var(
--spectrum-global-dimension-static-size-65
);--spectrum-progresscircle-s-indeterminate-overbackground-border-size:var(
--spectrum-global-dimension-static-size-25
);--spectrum-progresscircle-s-indeterminate-border-size:var(
--spectrum-global-dimension-static-size-25
);--spectrum-progresscircle-s-overbackground-border-size:var(
--spectrum-global-dimension-static-size-25
);--spectrum-progresscircle-s-border-size:var(
--spectrum-global-dimension-static-size-25
);--spectrum-progresscircle-m-indeterminate-overbackground-border-size:3px;--spectrum-progresscircle-m-indeterminate-border-size:3px;--spectrum-progresscircle-m-overbackground-border-size:3px;--spectrum-progresscircle-m-border-size:3px;--spectrum-radio-s-emphasized-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-radio-s-emphasized-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-radio-s-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-radio-s-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-radio-m-emphasized-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-radio-m-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-radio-l-emphasized-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-radio-l-emphasized-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-radio-l-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-radio-l-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-radio-xl-emphasized-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-radio-xl-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-rating-emphasized-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-rating-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-search-s-quiet-placeholder-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-search-s-quiet-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-search-s-quiet-touch-hit-x:var(
--spectrum-global-dimension-size-100
);--spectrum-search-s-quiet-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-search-s-placeholder-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-search-s-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-search-s-touch-hit-x:var(--spectrum-global-dimension-size-100);--spectrum-search-s-touch-hit-y:var(--spectrum-global-dimension-size-100);--spectrum-search-m-quiet-touch-hit-x:var(
--spectrum-global-dimension-size-100
);--spectrum-search-m-quiet-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-search-m-touch-hit-x:var(--spectrum-global-dimension-size-100);--spectrum-search-m-touch-hit-y:var(--spectrum-global-dimension-size-100);--spectrum-search-l-quiet-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-search-l-quiet-placeholder-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-search-l-quiet-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-search-l-quiet-touch-hit-x:var(
--spectrum-global-dimension-size-100
);--spectrum-search-l-quiet-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-search-l-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-search-l-placeholder-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-search-l-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-search-l-touch-hit-x:var(--spectrum-global-dimension-size-100);--spectrum-search-l-touch-hit-y:var(--spectrum-global-dimension-size-100);--spectrum-search-xl-quiet-touch-hit-x:var(
--spectrum-global-dimension-size-100
);--spectrum-search-xl-quiet-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-search-xl-touch-hit-x:var(--spectrum-global-dimension-size-100);--spectrum-search-xl-touch-hit-y:var(--spectrum-global-dimension-size-100);--spectrum-searchwithin-s-quiet-placeholder-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-searchwithin-s-quiet-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-searchwithin-s-placeholder-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-searchwithin-s-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-searchwithin-l-quiet-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-searchwithin-l-quiet-placeholder-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-searchwithin-l-quiet-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-searchwithin-l-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-searchwithin-l-placeholder-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-searchwithin-l-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-sidenav-multilevel-item-touch-hit-bottom:var(
--spectrum-global-dimension-static-size-25
);--spectrum-sidenav-multilevel-main-item-touch-hit-bottom:var(
--spectrum-global-dimension-static-size-25
);--spectrum-sidenav-item-touch-hit-bottom:var(
--spectrum-global-dimension-static-size-25
);--spectrum-sidenav-main-item-touch-hit-bottom:var(
--spectrum-global-dimension-static-size-25
);--spectrum-slider-s-tick-editable-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-slider-s-tick-editable-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-s-tick-editable-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-s-tick-editable-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-s-ramp-tick-editable-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-slider-s-ramp-tick-editable-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-s-ramp-tick-editable-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-s-ramp-tick-editable-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-s-range-tick-editable-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-slider-s-range-tick-editable-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-s-range-tick-editable-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-s-range-tick-editable-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-s-tick-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-slider-s-tick-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-s-tick-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-s-tick-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-s-ramp-tick-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-slider-s-ramp-tick-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-s-ramp-tick-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-s-ramp-tick-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-s-range-tick-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-slider-s-range-tick-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-s-range-tick-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-s-range-tick-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-s-editable-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-slider-s-editable-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-s-editable-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-s-editable-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-s-ramp-editable-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-slider-s-ramp-editable-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-s-ramp-editable-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-s-ramp-editable-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-s-range-editable-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-slider-s-range-editable-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-s-range-editable-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-s-range-editable-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-s-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-slider-s-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-s-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-s-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-s-ramp-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-slider-s-ramp-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-s-ramp-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-s-ramp-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-s-range-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-slider-s-range-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-s-range-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-s-range-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-m-tick-editable-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-m-tick-editable-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-m-tick-editable-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-m-ramp-tick-editable-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-m-ramp-tick-editable-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-m-ramp-tick-editable-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-m-range-tick-editable-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-m-range-tick-editable-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-m-range-tick-editable-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-m-tick-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-m-tick-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-m-tick-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-m-ramp-tick-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-m-ramp-tick-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-m-ramp-tick-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-m-range-tick-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-m-range-tick-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-m-range-tick-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-m-editable-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-m-editable-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-m-editable-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-m-ramp-editable-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-m-ramp-editable-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-m-ramp-editable-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-m-range-editable-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-m-range-editable-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-m-range-editable-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-m-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-m-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-m-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-m-ramp-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-m-ramp-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-m-ramp-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-m-range-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-m-range-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-m-range-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-l-tick-editable-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-slider-l-tick-editable-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-l-tick-editable-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-l-tick-editable-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-l-ramp-tick-editable-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-slider-l-ramp-tick-editable-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-l-ramp-tick-editable-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-l-ramp-tick-editable-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-l-range-tick-editable-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-slider-l-range-tick-editable-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-l-range-tick-editable-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-l-range-tick-editable-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-l-tick-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-slider-l-tick-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-l-tick-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-l-tick-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-l-ramp-tick-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-slider-l-ramp-tick-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-l-ramp-tick-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-l-ramp-tick-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-l-range-tick-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-slider-l-range-tick-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-l-range-tick-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-l-range-tick-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-l-editable-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-slider-l-editable-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-l-editable-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-l-editable-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-l-ramp-editable-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-slider-l-ramp-editable-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-l-ramp-editable-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-l-ramp-editable-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-l-range-editable-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-slider-l-range-editable-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-l-range-editable-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-l-range-editable-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-l-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-slider-l-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-l-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-l-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-l-ramp-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-slider-l-ramp-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-l-ramp-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-l-ramp-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-l-range-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-slider-l-range-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-l-range-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-l-range-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-xl-tick-editable-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-xl-tick-editable-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-xl-tick-editable-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-xl-ramp-tick-editable-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-xl-ramp-tick-editable-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-xl-ramp-tick-editable-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-xl-range-tick-editable-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-xl-range-tick-editable-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-xl-range-tick-editable-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-xl-tick-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-xl-tick-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-xl-tick-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-xl-ramp-tick-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-xl-ramp-tick-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-xl-ramp-tick-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-xl-range-tick-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-xl-range-tick-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-xl-range-tick-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-xl-editable-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-xl-editable-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-xl-editable-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-xl-ramp-editable-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-xl-ramp-editable-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-xl-ramp-editable-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-xl-range-editable-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-xl-range-editable-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-xl-range-editable-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-xl-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-xl-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-xl-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-xl-ramp-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-xl-ramp-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-xl-ramp-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-xl-range-track-touch-hit-y:var(
--spectrum-global-dimension-size-100
);--spectrum-slider-xl-range-handle-touch-hit-x:var(
--spectrum-global-dimension-size-200
);--spectrum-slider-xl-range-handle-touch-hit-y:var(
--spectrum-global-dimension-size-200
);--spectrum-statuslight-s-celery-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-statuslight-s-chartreuse-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-statuslight-s-fuchsia-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-statuslight-s-indigo-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-statuslight-s-info-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-statuslight-s-magenta-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-statuslight-s-neutral-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-statuslight-s-negative-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-statuslight-s-notice-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-statuslight-s-positive-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-statuslight-s-purple-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-statuslight-s-seafoam-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-statuslight-s-yellow-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-statuslight-l-celery-dot-size:var(
--spectrum-global-dimension-size-125
);--spectrum-statuslight-l-celery-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-statuslight-l-chartreuse-dot-size:var(
--spectrum-global-dimension-size-125
);--spectrum-statuslight-l-chartreuse-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-statuslight-l-fuchsia-dot-size:var(
--spectrum-global-dimension-size-125
);--spectrum-statuslight-l-fuchsia-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-statuslight-l-indigo-dot-size:var(
--spectrum-global-dimension-size-125
);--spectrum-statuslight-l-indigo-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-statuslight-l-info-dot-size:var(
--spectrum-global-dimension-size-125
);--spectrum-statuslight-l-info-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-statuslight-l-magenta-dot-size:var(
--spectrum-global-dimension-size-125
);--spectrum-statuslight-l-magenta-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-statuslight-l-neutral-dot-size:var(
--spectrum-global-dimension-size-125
);--spectrum-statuslight-l-neutral-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-statuslight-l-negative-dot-size:var(
--spectrum-global-dimension-size-125
);--spectrum-statuslight-l-negative-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-statuslight-l-notice-dot-size:var(
--spectrum-global-dimension-size-125
);--spectrum-statuslight-l-notice-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-statuslight-l-positive-dot-size:var(
--spectrum-global-dimension-size-125
);--spectrum-statuslight-l-positive-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-statuslight-l-purple-dot-size:var(
--spectrum-global-dimension-size-125
);--spectrum-statuslight-l-purple-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-statuslight-l-seafoam-dot-size:var(
--spectrum-global-dimension-size-125
);--spectrum-statuslight-l-seafoam-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-statuslight-l-yellow-dot-size:var(
--spectrum-global-dimension-size-125
);--spectrum-statuslight-l-yellow-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-statuslight-xl-celery-dot-size:var(
--spectrum-global-dimension-size-125
);--spectrum-statuslight-xl-chartreuse-dot-size:var(
--spectrum-global-dimension-size-125
);--spectrum-statuslight-xl-fuchsia-dot-size:var(
--spectrum-global-dimension-size-125
);--spectrum-statuslight-xl-indigo-dot-size:var(
--spectrum-global-dimension-size-125
);--spectrum-statuslight-xl-info-dot-size:var(
--spectrum-global-dimension-size-125
);--spectrum-statuslight-xl-magenta-dot-size:var(
--spectrum-global-dimension-size-125
);--spectrum-statuslight-xl-neutral-dot-size:var(
--spectrum-global-dimension-size-125
);--spectrum-statuslight-xl-negative-dot-size:var(
--spectrum-global-dimension-size-125
);--spectrum-statuslight-xl-notice-dot-size:var(
--spectrum-global-dimension-size-125
);--spectrum-statuslight-xl-positive-dot-size:var(
--spectrum-global-dimension-size-125
);--spectrum-statuslight-xl-purple-dot-size:var(
--spectrum-global-dimension-size-125
);--spectrum-statuslight-xl-seafoam-dot-size:var(
--spectrum-global-dimension-size-125
);--spectrum-statuslight-xl-yellow-dot-size:var(
--spectrum-global-dimension-size-125
);--spectrum-switch-s-emphasized-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-switch-s-emphasized-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-switch-s-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-switch-s-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-switch-m-emphasized-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-switch-m-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-switch-l-emphasized-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-switch-l-emphasized-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-switch-l-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-switch-l-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-switch-xl-emphasized-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-switch-xl-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-tabs-s-quiet-emphasized-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-tabs-s-quiet-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-s-quiet-emphasized-margin-left:-7px;--spectrum-tabs-s-quiet-emphasized-margin-right:-7px;--spectrum-tabs-s-quiet-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-tabs-s-quiet-focus-ring-border-radius:5px;--spectrum-tabs-s-quiet-margin-left:-7px;--spectrum-tabs-s-quiet-margin-right:-7px;--spectrum-tabs-s-emphasized-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-tabs-s-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-s-emphasized-margin-left:-7px;--spectrum-tabs-s-emphasized-margin-right:-7px;--spectrum-tabs-s-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-tabs-s-focus-ring-border-radius:5px;--spectrum-tabs-s-margin-left:-7px;--spectrum-tabs-s-margin-right:-7px;--spectrum-tabs-s-vertical-quiet-emphasized-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-tabs-s-vertical-quiet-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-s-vertical-quiet-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-tabs-s-vertical-quiet-focus-ring-border-radius:5px;--spectrum-tabs-s-vertical-emphasized-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-tabs-s-vertical-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-s-vertical-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-tabs-s-vertical-focus-ring-border-radius:5px;--spectrum-tabs-s-compact-quiet-emphasized-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-tabs-s-compact-quiet-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-s-compact-quiet-emphasized-margin-left:-7px;--spectrum-tabs-s-compact-quiet-emphasized-margin-right:-7px;--spectrum-tabs-s-compact-quiet-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-tabs-s-compact-quiet-focus-ring-border-radius:5px;--spectrum-tabs-s-compact-quiet-margin-left:-7px;--spectrum-tabs-s-compact-quiet-margin-right:-7px;--spectrum-tabs-s-compact-emphasized-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-tabs-s-compact-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-s-compact-emphasized-margin-left:-7px;--spectrum-tabs-s-compact-emphasized-margin-right:-7px;--spectrum-tabs-s-compact-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-tabs-s-compact-focus-ring-border-radius:5px;--spectrum-tabs-s-compact-margin-left:-7px;--spectrum-tabs-s-compact-margin-right:-7px;--spectrum-tabs-s-compact-vertical-quiet-emphasized-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-tabs-s-compact-vertical-quiet-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-s-compact-vertical-quiet-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-tabs-s-compact-vertical-quiet-focus-ring-border-radius:5px;--spectrum-tabs-s-compact-vertical-emphasized-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-tabs-s-compact-vertical-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-s-compact-vertical-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-tabs-s-compact-vertical-focus-ring-border-radius:5px;--spectrum-tabs-m-quiet-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-m-quiet-emphasized-margin-left:-8px;--spectrum-tabs-m-quiet-emphasized-margin-right:-8px;--spectrum-tabs-m-quiet-focus-ring-border-radius:5px;--spectrum-tabs-m-quiet-margin-left:-8px;--spectrum-tabs-m-quiet-margin-right:-8px;--spectrum-tabs-m-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-m-emphasized-margin-left:-8px;--spectrum-tabs-m-emphasized-margin-right:-8px;--spectrum-tabs-m-focus-ring-border-radius:5px;--spectrum-tabs-m-margin-left:-8px;--spectrum-tabs-m-margin-right:-8px;--spectrum-tabs-m-vertical-quiet-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-m-vertical-quiet-focus-ring-border-radius:5px;--spectrum-tabs-m-vertical-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-m-vertical-focus-ring-border-radius:5px;--spectrum-tabs-m-compact-quiet-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-m-compact-quiet-emphasized-margin-left:-8px;--spectrum-tabs-m-compact-quiet-emphasized-margin-right:-8px;--spectrum-tabs-m-compact-quiet-focus-ring-border-radius:5px;--spectrum-tabs-m-compact-quiet-margin-left:-8px;--spectrum-tabs-m-compact-quiet-margin-right:-8px;--spectrum-tabs-m-compact-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-m-compact-emphasized-margin-left:-8px;--spectrum-tabs-m-compact-emphasized-margin-right:-8px;--spectrum-tabs-m-compact-focus-ring-border-radius:5px;--spectrum-tabs-m-compact-margin-left:-8px;--spectrum-tabs-m-compact-margin-right:-8px;--spectrum-tabs-m-compact-vertical-quiet-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-m-compact-vertical-quiet-focus-ring-border-radius:5px;--spectrum-tabs-m-compact-vertical-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-m-compact-vertical-focus-ring-border-radius:5px;--spectrum-tabs-l-quiet-emphasized-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-tabs-l-quiet-emphasized-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-tabs-l-quiet-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-l-quiet-emphasized-margin-left:-9px;--spectrum-tabs-l-quiet-emphasized-margin-right:-9px;--spectrum-tabs-l-quiet-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-tabs-l-quiet-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-tabs-l-quiet-focus-ring-border-radius:5px;--spectrum-tabs-l-quiet-margin-left:-9px;--spectrum-tabs-l-quiet-margin-right:-9px;--spectrum-tabs-l-emphasized-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-tabs-l-emphasized-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-tabs-l-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-l-emphasized-margin-left:-9px;--spectrum-tabs-l-emphasized-margin-right:-9px;--spectrum-tabs-l-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-tabs-l-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-tabs-l-focus-ring-border-radius:5px;--spectrum-tabs-l-margin-left:-9px;--spectrum-tabs-l-margin-right:-9px;--spectrum-tabs-l-vertical-quiet-emphasized-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-tabs-l-vertical-quiet-emphasized-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-tabs-l-vertical-quiet-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-l-vertical-quiet-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-tabs-l-vertical-quiet-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-tabs-l-vertical-quiet-focus-ring-border-radius:5px;--spectrum-tabs-l-vertical-emphasized-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-tabs-l-vertical-emphasized-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-tabs-l-vertical-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-l-vertical-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-tabs-l-vertical-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-tabs-l-vertical-focus-ring-border-radius:5px;--spectrum-tabs-l-compact-quiet-emphasized-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-tabs-l-compact-quiet-emphasized-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-tabs-l-compact-quiet-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-l-compact-quiet-emphasized-margin-left:-9px;--spectrum-tabs-l-compact-quiet-emphasized-margin-right:-9px;--spectrum-tabs-l-compact-quiet-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-tabs-l-compact-quiet-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-tabs-l-compact-quiet-focus-ring-border-radius:5px;--spectrum-tabs-l-compact-quiet-margin-left:-9px;--spectrum-tabs-l-compact-quiet-margin-right:-9px;--spectrum-tabs-l-compact-emphasized-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-tabs-l-compact-emphasized-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-tabs-l-compact-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-l-compact-emphasized-margin-left:-9px;--spectrum-tabs-l-compact-emphasized-margin-right:-9px;--spectrum-tabs-l-compact-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-tabs-l-compact-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-tabs-l-compact-focus-ring-border-radius:5px;--spectrum-tabs-l-compact-margin-left:-9px;--spectrum-tabs-l-compact-margin-right:-9px;--spectrum-tabs-l-compact-vertical-quiet-emphasized-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-tabs-l-compact-vertical-quiet-emphasized-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-tabs-l-compact-vertical-quiet-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-l-compact-vertical-quiet-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-tabs-l-compact-vertical-quiet-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-tabs-l-compact-vertical-quiet-focus-ring-border-radius:5px;--spectrum-tabs-l-compact-vertical-emphasized-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-tabs-l-compact-vertical-emphasized-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-tabs-l-compact-vertical-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-l-compact-vertical-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-tabs-l-compact-vertical-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-tabs-l-compact-vertical-focus-ring-border-radius:5px;--spectrum-tabs-xl-quiet-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-xl-quiet-emphasized-margin-left:-10px;--spectrum-tabs-xl-quiet-emphasized-margin-right:-10px;--spectrum-tabs-xl-quiet-focus-ring-border-radius:5px;--spectrum-tabs-xl-quiet-margin-left:-10px;--spectrum-tabs-xl-quiet-margin-right:-10px;--spectrum-tabs-xl-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-xl-emphasized-margin-left:-10px;--spectrum-tabs-xl-emphasized-margin-right:-10px;--spectrum-tabs-xl-focus-ring-border-radius:5px;--spectrum-tabs-xl-margin-left:-10px;--spectrum-tabs-xl-margin-right:-10px;--spectrum-tabs-xl-vertical-quiet-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-xl-vertical-quiet-focus-ring-border-radius:5px;--spectrum-tabs-xl-vertical-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-xl-vertical-focus-ring-border-radius:5px;--spectrum-tabs-xl-compact-quiet-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-xl-compact-quiet-emphasized-margin-left:-10px;--spectrum-tabs-xl-compact-quiet-emphasized-margin-right:-10px;--spectrum-tabs-xl-compact-quiet-focus-ring-border-radius:5px;--spectrum-tabs-xl-compact-quiet-margin-left:-10px;--spectrum-tabs-xl-compact-quiet-margin-right:-10px;--spectrum-tabs-xl-compact-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-xl-compact-emphasized-margin-left:-10px;--spectrum-tabs-xl-compact-emphasized-margin-right:-10px;--spectrum-tabs-xl-compact-focus-ring-border-radius:5px;--spectrum-tabs-xl-compact-margin-left:-10px;--spectrum-tabs-xl-compact-margin-right:-10px;--spectrum-tabs-xl-compact-vertical-quiet-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-xl-compact-vertical-quiet-focus-ring-border-radius:5px;--spectrum-tabs-xl-compact-vertical-emphasized-focus-ring-border-radius:5px;--spectrum-tabs-xl-compact-vertical-focus-ring-border-radius:5px;--spectrum-tag-s-removable-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-tag-s-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-tag-s-removable-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-tag-s-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-tag-s-removable-avatartext-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-tag-s-avatartext-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-tag-m-removable-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-tag-m-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-tag-m-removable-avatartext-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-tag-m-avatartext-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-tag-l-removable-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-tag-l-removable-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-tag-l-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-tag-l-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-tag-l-removable-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-tag-l-removable-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-tag-l-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-tag-l-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-tag-l-removable-avatartext-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-tag-l-removable-avatartext-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-tag-l-avatartext-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-tag-l-avatartext-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-textarea-s-multiline-quiet-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-textarea-s-multiline-quiet-placeholder-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-textarea-s-multiline-quiet-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-s-multiline-quiet-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-s-quiet-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-textarea-s-quiet-placeholder-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-textarea-s-quiet-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-s-quiet-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-s-multiline-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-textarea-s-multiline-placeholder-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-textarea-s-multiline-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-s-multiline-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-s-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-textarea-s-placeholder-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-textarea-s-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-s-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-m-multiline-quiet-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-m-multiline-quiet-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-m-quiet-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-m-quiet-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-m-multiline-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-m-multiline-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-m-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-m-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-l-multiline-quiet-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-textarea-l-multiline-quiet-placeholder-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-textarea-l-multiline-quiet-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-l-multiline-quiet-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-l-quiet-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-textarea-l-quiet-placeholder-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-textarea-l-quiet-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-l-quiet-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-l-multiline-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-textarea-l-multiline-placeholder-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-textarea-l-multiline-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-l-multiline-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-l-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-textarea-l-placeholder-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-textarea-l-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-l-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-xl-multiline-quiet-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-xl-multiline-quiet-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-xl-quiet-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-xl-quiet-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-xl-multiline-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-xl-multiline-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-xl-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textarea-xl-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-s-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-s-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-s-quiet-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-textfield-s-quiet-texticon-placeholder-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-textfield-s-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-s-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-s-quiet-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-textfield-s-quiet-textonly-placeholder-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-textfield-s-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-s-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-s-texticon-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-textfield-s-texticon-placeholder-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-textfield-s-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-s-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-s-textonly-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-textfield-s-textonly-placeholder-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-textfield-m-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-m-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-m-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-m-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-m-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-m-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-m-texticon-padding-left:var(
--spectrum-global-dimension-size-125
);--spectrum-textfield-m-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-m-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-l-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-l-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-l-quiet-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-textfield-l-quiet-texticon-placeholder-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-textfield-l-quiet-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-textfield-l-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-l-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-l-quiet-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-textfield-l-quiet-textonly-placeholder-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-textfield-l-quiet-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-textfield-l-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-l-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-l-texticon-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-textfield-l-texticon-placeholder-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-textfield-l-texticon-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-textfield-l-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-l-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-l-textonly-text-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-textfield-l-textonly-placeholder-padding-top:var(
--spectrum-global-dimension-size-115
);--spectrum-textfield-l-textonly-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-textfield-xl-quiet-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-xl-quiet-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-xl-quiet-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-xl-quiet-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-xl-texticon-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-xl-texticon-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-xl-textonly-touch-hit-x:var(
--spectrum-global-dimension-static-size-100
);--spectrum-textfield-xl-textonly-touch-hit-y:var(
--spectrum-global-dimension-static-size-100
);--spectrum-tooltip-neutral-text-margin-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-tooltip-info-text-margin-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-tooltip-positive-text-margin-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-tooltip-negative-text-margin-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-treeview-s-item-text-padding-bottom:var(
--spectrum-global-dimension-static-size-65
);--spectrum-treeview-l-item-icon-size:var(
--spectrum-global-dimension-static-size-250
);--spectrum-treeview-l-item-text-padding-top:var(
--spectrum-global-dimension-size-115
)}:host,:root{--spectrum-global-alias-appframe-border-size:2px}
`;
export default styles;